import "antd/es/config-provider/style";
import _ConfigProvider from "antd/es/config-provider";
import _extends from "@babel/runtime/helpers/esm/extends";
import React, { createContext, useReducer, useEffect, useMemo } from 'react';
import antdEn from 'antd/lib/locale-provider/en_US';
import { useTranslation } from 'react-i18next';
import moment from 'moment';
import { warning } from '@swuif/utils';
import { localeConfigActions } from './actions';
import { initialState, reducer } from './reducer';
import { isI18nReady, createMeta } from './utils';
export var LocaleInnerConfigDispatchContext = createContext(undefined);
export var LocaleInnerConfigStateContext = createContext(undefined);
export var LocaleInnerConfigProvider = function LocaleInnerConfigProvider(_ref) {
  var languageMeta = _ref.languageMeta,
      fallbackLanguage = _ref.fallbackLanguage,
      children = _ref.children;
  var meta = useMemo(function () {
    return createMeta(languageMeta);
  }, [languageMeta]);

  var _useTranslation = useTranslation('swuif'),
      t = _useTranslation[0],
      i18n = _useTranslation[1];

  var _useReducer = useReducer(reducer, _extends({}, initialState, {
    language: isI18nReady(i18n) ? i18n.language : fallbackLanguage,
    meta: meta
  })),
      state = _useReducer[0],
      dispatch = _useReducer[1];

  var ready = isI18nReady(i18n);
  useEffect(function () {
    function setLanguage(lang) {
      moment.locale(lang);
      dispatch(localeConfigActions.setLanguage(lang));
      process.env.NODE_ENV !== "production" ? warning(languageMeta[lang] != null, "No meta configured for language " + lang) : void 0;
      process.env.NODE_ENV !== "production" ? warning(languageMeta[lang] != null && languageMeta[lang].antd != null, "No antd locale data provided for language " + lang) : void 0;
    }

    if (ready) {
      i18n.on('languageChanged', setLanguage);
    }

    return function () {
      if (ready) {
        i18n.off('languageChanged', setLanguage);
      }
    };
  }, [t, ready, languageMeta, i18n]);
  return React.createElement(_ConfigProvider, {
    locale: isI18nReady(i18n) ? (languageMeta[i18n.language] || {}).antd || antdEn : antdEn
  }, React.createElement(LocaleInnerConfigDispatchContext.Provider, {
    value: dispatch
  }, React.createElement(LocaleInnerConfigStateContext.Provider, {
    value: state
  }, children)));
};